import { DownloadButton } from "_components/buttons";
import SearchInput from "_components/SearchInput";
import { CustomTable } from "_components/table/CustomTable";
import { eventsActions } from "_store";
import { sidePanelActions } from "_store/sidePanel.slice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export { DatasTableBusLastEvents }

function DatasTableBusLastEvents ({events}) {

    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if(events?.data?.events) {
            setData(events.data.events);
            setFilteredData(events.data.events);
        }
    }, [events]);

    useEffect(() => {
        return () => {            
            dispatch(eventsActions.clearData());
        }
    }, [])

    const handleShowSidePanel = (alert) => {
        dispatch(sidePanelActions.openPanel({ type: 'alert', data: alert }));        
    }

    const headers = [   
        { label: 'Type', key: 'HEADER_TYPE', type: 'string', canToggle: false, visible: true },
        { label: "Code", key: '', type: 'string', icon: 'HEADER_CODE', canToggle: false, visible: true },
        { label: 'Niveau', key: 'URGENCY_LEVEL', type: 'string', canToggle: false, visible: true },  
        { label: 'Description', key: 'EVENT_DESC_FR', type: 'string', canToggle: false, visible: true },      
        { label: 'Date', key: 'HEADER_EVTDATE', type: 'string', canToggle: false, visible: true },
        { label: 'SOC', key: 'CONTEXT.SOC', type: 'string', canToggle: false, visible: true },
        { label: 'Odomètre', key: 'HEADER_DST', type: 'string', canToggle: false, visible: true }, 
        { label: '', key: 'alert_info', type: 'action', action: handleShowSidePanel, icon: 'loupeOutlined', canToggle: false, visible: true, title: 'Voir le détail de l\'alerte'}       
    ]

    // Fonction pour mettre à jour les données filtrées
    const handleFilteredData = (newFilteredData) => {
        if (JSON.stringify(newFilteredData) !== JSON.stringify(filteredData)) {
            setFilteredData(newFilteredData);
        }
    };
    
    return (
        <>
            {data && (
                <div className='custom-table-container' >
                    <div className={'flex justify-between items-end'}>
                        <div className="flex items-end">
                            <span className={'small-title-customtable mr-2 '}>
                                {filteredData?.length}                                
                            </span>
                            <i className="pb-0.5"> événements survenus pour la période sélectionnée</i>
                        </div>
                        <div className='flex gap-4'>
                            <SearchInput data={data} onFilteredData={handleFilteredData} />
                            <DownloadButton title={`Rapport des événements`} headers={headers} data={data} />
                        </div>
                    </div>                    
                    <div className={"my-4 "}>
                        <CustomTable data={filteredData} headers={headers} maxHeight={'60vh'}/>
                    </div>
                    
                </div>
            )}
        </>
    )    
}